/* Publish by EComposer at 2026-10-14 09:18:47*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jt847tt13qs"]=  window.__ectimmers["ecom-jt847tt13qs"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-jt847tt13qs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jt847tt13qs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qka30qumhik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qka30qumhik', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0tispefjr6wp"]=  window.__ectimmers["ecom-0tispefjr6wp"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-0tispefjr6wp"]["1xfsz03yd"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-0tispefjr6wp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0tispefjr6wp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5hhbliqxzs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5hhbliqxzs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-540gx95qpvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-540gx95qpvp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ggef5azz966').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ggef5azz966', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpcnqwlcbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpcnqwlcbx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ltyza1p8e0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ltyza1p8e0c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6ofidemebn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6ofidemebn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yh0lb22p9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yh0lb22p9r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jeh2tb885ah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jeh2tb885ah', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbjjcvzxmar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbjjcvzxmar', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-olfkgiu26f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-olfkgiu26f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmhks55qx2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmhks55qx2n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnqvhlg8x3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnqvhlg8x3b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-io7m9fkumt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-io7m9fkumt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kzvi4nf2mfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kzvi4nf2mfl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxq9oop3pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxq9oop3pl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnqye4ksyw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnqye4ksyw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1nulxj4015').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1nulxj4015', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-81u9w0t49db').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-81u9w0t49db', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5sp4kotkn4b"]=  window.__ectimmers["ecom-5sp4kotkn4b"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-5sp4kotkn4b"]["wetlnzxmy"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-5sp4kotkn4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5sp4kotkn4b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lm6djdkk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lm6djdkk9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c97mmfo92pe"]=  window.__ectimmers["ecom-c97mmfo92pe"] || {};
if(!this.$el)return;const t=this.$el,e=function(o){if(window.EComModal)return o();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&o()});return}let n=0;const r= window.__ectimmers["ecom-c97mmfo92pe"]["x7vhysfrf"] = setInterval(function(){window.EComModal?(clearInterval(r),o()):++n>=300&&clearInterval(r)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var i=this.$el.querySelectorAll("[ecom-modal]"),s=this.id;i.length&&e(function(){new window.EComModal(i,{cssClass:["ecom-container-lightbox-"+s]})})}if(this.settings.link!=="lightbox"&&this.settings.link!=="custom"&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){let o=t.querySelector(".ecom-image-picture-hover"),n=t.querySelector(".ecom-image-picture.ecom-image-has-hover");if(!o||!n)return;o.addEventListener("click",function(){n.classList.add("image-active"),o.classList.add("image-hidden")}),n.addEventListener("click",function(){n.classList.remove("image-active"),o.classList.remove("image-hidden")})}

                    });
                    
                        document.querySelectorAll('.ecom-c97mmfo92pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c97mmfo92pe', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hipfero0c5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hipfero0c5b', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5to24hqybk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5to24hqybk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdhinbrh45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdhinbrh45', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5lx8bu05d7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5lx8bu05d7s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m71i45ivop9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m71i45ivop9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfmppvhcwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfmppvhcwg', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lq96mejgto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lq96mejgto', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5e5f2fjhwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5e5f2fjhwp', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-282bdhcwz5m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-282bdhcwz5m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vi2r7hahbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vi2r7hahbe', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-to2jlxy6p4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-to2jlxy6p4r', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3fttd9otce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3fttd9otce', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98rk807b12').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98rk807b12', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-01l5324h5l75').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-01l5324h5l75', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99cm3gkgz8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99cm3gkgz8g', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10k8o8num2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10k8o8num2q', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}